var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticClass: "table",
      attrs: {
        data: _vm.saleList,
        size: "mini",
        "highlight-current-row": "",
        "header-cell-style": { fontWeight: "bold" },
      },
      on: { "selection-change": _vm.handleSelectionChange },
    },
    [
      !_vm.isDisabled && !_vm.isEditable
        ? _c("el-table-column", { attrs: { type: "selection", width: "45" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.needQtyAndAmount
        ? _c("el-table-column", {
            attrs: { prop: "saleQty", label: "售后数量", "min-width": 180 },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      (!_vm.isDisabled && _vm.selectIds.includes(scope.row)) ||
                      _vm.isEditable
                        ? _c("el-input-number", {
                            staticStyle: { width: "160px" },
                            attrs: {
                              min: 1,
                              max: scope.row.skuQuantity,
                              placeholder: "请输入",
                              size: "small",
                              step: 1,
                              "step-strictly": true,
                              disabled: _vm.isCompensationType,
                            },
                            on: {
                              change: function (val) {
                                return _vm.handleQtyChange(scope.row, val)
                              },
                            },
                            model: {
                              value: scope.row.saleQty,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "saleQty", $$v)
                              },
                              expression: "scope.row.saleQty",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(scope.row.saleQty))]),
                    ]
                  },
                },
              ],
              null,
              false,
              353621370
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.needQtyAndAmount
        ? _c("el-table-column", {
            attrs: { prop: "saleAmount", label: "售后金额", "min-width": 120 },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      (!_vm.isDisabled && _vm.selectIds.includes(scope.row)) ||
                      _vm.isEditable
                        ? _c("el-input-number", {
                            staticStyle: { width: "100px" },
                            attrs: {
                              controls: false,
                              placeholder: "自动计算",
                              precision: 2,
                              min: 0,
                              max: _vm.getMaxRefundAmount(scope.row),
                              size: "small",
                              disabled: _vm.isCompensationType,
                            },
                            on: {
                              change: function (val) {
                                return _vm.handleAmountChange(scope.row, val)
                              },
                            },
                            model: {
                              value: scope.row.saleAmount,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "saleAmount", $$v)
                              },
                              expression: "scope.row.saleAmount",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(scope.row.saleAmount))]),
                    ]
                  },
                },
              ],
              null,
              false,
              3127229464
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "saleQty", label: "关联订单", "min-width": "160" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm.orderNo
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#606266",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("订单编号：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#303133",
                            "font-size": "13px",
                            "margin-bottom": "4px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.orderNo))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-text",
                          on: { click: _vm.goToOrderDetail },
                        },
                        [_vm._v("订单详情 >")]
                      ),
                    ])
                  : _c("div", [_vm._v("暂无")]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { label: "图片", "min-width": "60" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("el-image", {
                  attrs: { src: scope.row.skuImg },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuId", label: "skuID", "min-width": "60" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuCode", label: "sku编号", "min-width": "120" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuName", label: "sku名称", "min-width": "120" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuAttr", label: "规格", "min-width": "120" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuQuantity", label: "数量", "min-width": "50" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuPrice", label: "商品单价", "min-width": "95" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "skuTotalPrice", label: "商品总价", "min-width": "95" },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "skuCouponPrice",
          label: "商品优惠金额",
          "min-width": "100",
        },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "skuInstantDiscount",
          label: "立减金额",
          "min-width": "100",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.formatInstantDiscount(scope.row)) +
                    "\n          "
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "afterSalePriceTotal",
          label: "退款总金额",
          "min-width": "95",
        },
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "giveIntegral", label: "返积分", "min-width": "80" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(scope.row.giveIntegral || 0) +
                    "\n          "
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showOneCardActivationColumn
        ? _c("el-table-column", {
            attrs: { label: "是否激活", "min-width": "90" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      Number(scope.row.oneCardType) !== 1
                        ? _c("span", [
                            _vm._v(
                              _vm._s(scope.row.oneCardActivated ? "是" : "否")
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              2063875074
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "售后申请号", "min-width": "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.orderAfsNo) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              454004614
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "第三方售后状态", "min-width": "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.thirdAfsStatusText) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              566548099
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "第三方售后类型", "min-width": "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.thirdAfsTypeText) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1751325743
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "第三方取件方式", "min-width": "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.thirdPickTypeText) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1020120778
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "第三方售后申请状态", "min-width": "150" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.thirdApplyStatusText) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2183661507
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "第三方退款状态", "min-width": "120" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(scope.row.thirdRefundStatusText) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3313463801
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showLypFields
        ? _c("el-table-column", {
            attrs: { label: "第三方退款金额", "min-width": "130" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.formatThirdRefundAmount(
                              scope.row.thirdRefundAmount
                            )
                          ) +
                          "\n          "
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              1562326271
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }